import React, { useContext, useEffect, useState } from 'react';
import Menu from './homePage/menu/menu';
import MainPage from './MainPage';
import Epg from './homePage/epg/epg';
import { CURRENT_PAGE, DISPLAYPLATFORM } from '../constant';
import TopMenuWeb from './homePage/menu/topmenuweb';
import PiPage from './homePage/components/PiPage';
import { Box, CircularProgress } from '@mui/material';
import { PlatformContext } from '../contexts/platformContext';

const MainWrapper = ({ focusKeyParam,
    page, ottSetting, menu, isOpenPiPage, pageState }) => {

    const [currentPage, setCurrentPage] = useState(page);
    const [currentPageUnderMenu, setCurrentPageUnderMenu] = useState(isOpenPiPage ? CURRENT_PAGE.PI_PAGE : CURRENT_PAGE.MAIN);
    const [isLoading, setIsLoading] = useState(false);
    const displayPlatform = useContext(PlatformContext);

    useEffect(() => {
        setCurrentPage(page);
        setCurrentPageUnderMenu(isOpenPiPage ? CURRENT_PAGE.PI_PAGE : CURRENT_PAGE.MAIN);
    }, [page, isOpenPiPage]);

    const renderContent = () => {
        switch (currentPage?._id) {
            case CURRENT_PAGE.EPG:
                return (
                    <Epg
                        focusKeyParam={"epg"}
                        page={currentPage}
                        ottSetting={ottSetting}
                    />
                );
            default:
                return (
                    isLoading ?
                        <Box display="flex" justifyContent="center" alignItems="end" minHeight="50vh">
                            <CircularProgress />
                        </Box> :
                        <MainPage
                            setCurrentPage={setCurrentPage}
                            focusKeyParam={focusKeyParam}
                            page={currentPage}
                            ottSetting={ottSetting}
                            currentPageUnderMenu={currentPageUnderMenu}
                            setCurrentPageUnderMenu={setCurrentPageUnderMenu}
                            pageState={pageState}
                        />
                );
        }
    };

    return (
        <div style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: displayPlatform == DISPLAYPLATFORM.WEB ? "column" : "row",
        }}>
            {displayPlatform == DISPLAYPLATFORM.TV && <Menu focusKey={"MENU"} ottSetting={ottSetting} menu={menu} setCurrentPage={setCurrentPage} currentPage={currentPage} setIsLoading={setIsLoading} />}
            {displayPlatform == DISPLAYPLATFORM.WEB && <TopMenuWeb focusKey={"MENU"} ottSetting={ottSetting} menu={menu} setCurrentPage={setCurrentPage} currentPage={currentPage} setIsLoading={setIsLoading} setCurrentPageUnderMenu={setCurrentPageUnderMenu} />}
            {
                renderContent()
            }
        </div>
    );
}

export default MainWrapper;
